import { encryptStorage } from 'src/Util'
import { documentsAPI } from '../api'

//Action Types
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'


//Action Creators
export const getDashboardData = () => (dispatch) => {
    console.log('dashboard data action call')
    documentsAPI
      .post(`/admin/dashboard/`, {
        companyName: "",
        offset: 0,
        limit: 1000
      })
      .then((response) => {
        console.log('Actions Admin Dashboard -> Response', response)
        dispatch({
          type: SET_DASHBOARD_DATA,
          payload: response.data
        })
      })
  
  
    
  }